/**
 * Add to Cart Action
 * Triggered by: arc:action:addToCart
 */

import { addToCartMutation } from '@src/hooks/useShoppingBasketCart';

export const runAddToCart = async (data = {}) => {
  try {
    let { variantId, quantity = 1, properties = {} } = data;

    // If no variantId provided, try to get it from product context
    if (!variantId) {
      const productContext = window.getProductContext?.();
      if (productContext && productContext.variantId) {
        variantId = productContext.variantId;
      }
    }

    if (!variantId) {
      throw new Error('Variant ID is required and could not be determined from product context');
    }

    // Dispatch loading start event
    window.dispatchEvent(
      new CustomEvent('cart:add_loading_start', {
        detail: {
          variantId,
          quantity,
          properties
        }
      })
    );

    // Add to cart
    const addToCartData = [
      {
        variantId,
        quantity,
        properties
      }
    ];
    const result = await addToCartMutation('/cart/add.js', {
      arg: addToCartData
    });

    // Dispatch loading end event
    window.dispatchEvent(
      new CustomEvent('cart:add_loading_end', {
        detail: {
          variantId,
          quantity,
          properties,
          success: true
        }
      })
    );

    // Dispatch success event - this will trigger useShoppingBasket to refresh
    window.dispatchEvent(
      new CustomEvent('cart:item_added', {
        detail: {
          item: result,
          variantId,
          quantity,
          properties
        }
      })
    );

    return {
      success: true,
      item: result,
      message: 'Item added to cart successfully'
    };
  } catch (error) {
    console.error('Error adding to cart:', error);

    // Dispatch loading end event for error case
    window.dispatchEvent(
      new CustomEvent('cart:add_loading_end', {
        detail: {
          variantId: data.variantId,
          quantity: data.quantity,
          properties: data.properties,
          success: false,
          error: error.message
        }
      })
    );

    // Dispatch error event
    window.dispatchEvent(
      new CustomEvent('cart:add_error', {
        detail: {
          error: error.message,
          variantId: data.variantId,
          quantity: data.quantity
        }
      })
    );

    return {
      success: false,
      error: error.message
    };
  }
};

export default runAddToCart;
